import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {ApprovalPending} from '../../../shared/dto/approval-pending';
import {DocumentTypeModel} from '../../../shared/dto/document-type.model';
import {DocumentDetailsService} from '../../../service/document-details.service';
import Swal from "sweetalert2";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {DocumentViewerComponent} from '../document-viewer/document-viewer.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-viwer',
  templateUrl: './document-viwer.component.html',
  styleUrls: ['./document-viwer.component.scss']
})
export class DocumentViwerComponent implements OnInit {
  @Input() applicationId: number;
  public documentTypeModel: DocumentTypeModel[];
  displayedColumns: string[] = ['description','action'];
  dataSource: MatTableDataSource<any>;
  public pages: any = [];
  public loader: boolean = false;
  public safeUrl: SafeResourceUrl;
  docType: DocumentTypeModel = new DocumentTypeModel();
  isLoading: boolean = false;

  constructor(private applicantRequestService: ApplicantRequestService, private documentDetailsService: DocumentDetailsService,
              private sanitizer: DomSanitizer, private modalService: NgbModal,) { }

  ngOnInit() {
    this.getDocumentType();
  }

  getDocumentType() {
    this.isLoading = true;
    this.applicantRequestService.getDocumentType(this.applicationId).subscribe(
      (result: any ) => {
        this.isLoading = false;
        this.documentTypeModel = result;
        this.dataSource = new MatTableDataSource(this.documentTypeModel);
      }
    );
  }

  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  viewDoc(documentTypeCode:string) {
    this.docType.appRefID = this.applicationId;
    this.docType.documentTypeCode = documentTypeCode;

    const modalRef = this.modalService.open(DocumentViewerComponent,{size: 'lg'});
    let data = {
      doc: this.docType,
    }

    modalRef.componentInstance.fromParent = data;
  }
}
